<script lang="ts">
    export let color: string = "var(--grayDark)";
    import Wave from "../icons/WaveIcon.svelte";
</script>

<div class="divider-wave" style="--color: {color}">
    <svelte:component this={Wave} />
</div>

<style lang="scss">
    @import "./src/vars";

    .divider-wave {
        width: 100%;
        height: 0px;
        position: relative;

        :global(svg) {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: auto;
            transform: translateY(-100%);
            color: --color;
        }
    }
</style>
